import React from 'react';

function Contact(props) {
    return (
        <div>Contact Me</div>
    )
};

export default Contact;